export { TutorTrainingVideo, type TutorTrainingVideoProps } from "./TutorTrainingVideo"
